/* ─── Field wrapper ─── */

.field {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--space-3);
  cursor: pointer;
}

.field[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

.field[data-disabled] .root {
  opacity: 1;
}

/* ─── Box ─── */

.root {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
  margin-block-start: 0.1875rem; /* align with first line of label text */
  border: 2px solid var(--md-outline);
  border-radius: var(--shape-xs);
  background: transparent;
  cursor: inherit;
  transition: background var(--motion-duration-short3)
      var(--motion-easing-standard),
    border-color var(--motion-duration-short3) var(--motion-easing-standard);
}

.root[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

.root[data-checked],
.root[data-indeterminate] {
  background: var(--md-primary);
  border-color: var(--md-primary);
}

.root:focus-visible {
  --focus-ring-offset: var(--focus-ring-offset-outset);
}

/* ─── Indicator (checkmark / dash) ─── */

.indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--md-on-primary);
  transform: scale(0);
  transition: transform var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.root[data-checked] .indicator,
.root[data-indeterminate] .indicator {
  transform: scale(1);
}

.indicator svg {
  width: 0.75rem;
  height: 0.75rem;
}

/* ─── Label ─── */

.label {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  cursor: inherit;
  user-select: none;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-error);
  margin: 0;
}
